import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import { validateHwSerials } from '~/features/base/utils/hwSerialValidator';
import MultiselectOTA from '../../../base/components/forms/ota/MultiselectOTA';
import { useFetchVehicleGroupsQuery } from '~/api/vehicleGroup/VehicleGroup.api';
import TextAreaFormItem from '~/features/base/components/forms/TextAreaFormItem';
import { validateVINs } from '~/features/base/utils/vinValidator';
import { validateShortVINs } from '~/features/devices/utils/deviceQuery';
import { FILTER_IDS } from '~/features/devices/constants/filterMenuConstants';
import HeartWrapper from '~/features/devices/components/deviceFilters/HeartWrapper';

interface IncludeDevicesSectionProps {
    control: Control<any>;
}

const IncludeDevicesSection: React.FC<IncludeDevicesSectionProps> = ({ control }) => {
    const { data: groups = [] } = useFetchVehicleGroupsQuery({});
    const groupOptions = groups.map(group => group.name);

    return (
        <div>
            <h4><FormattedMessage id='intl-msg:includeDevices' defaultMessage='Include Devices'/></h4>
            <hr/>
            <div id={FILTER_IDS.GROUPS}>
                {groups.length > 0 ? (
                    <HeartWrapper key={`groups-${groups.length}`}>
                        <Controller
                            name='vehicleGroupWhitelist'
                            control={control}
                            render={({ field: { value, onChange } }) => (
                                <MultiselectOTA
                                    labelId='intl-msg:groups'
                                    options={groupOptions}
                                    value={value}
                                    onChange={onChange}
                                />
                            )}
                        />
                    </HeartWrapper>
                ) : (
                    <Controller
                        name='vehicleGroupWhitelist'
                        control={control}
                        render={({ field: { value, onChange } }) => (
                            <MultiselectOTA
                                labelId='intl-msg:groups'
                                options={groupOptions}
                                value={value}
                                onChange={onChange}
                            />
                        )}
                    />
                )}
            </div>
            <div id={FILTER_IDS.DEVICE_WHITELIST}>
                <HeartWrapper>
                    <Controller
                        name='deviceWhitelist'
                        control={control}
                        render={({ field: { value = [], onChange } }) => {
                            const normalizedValue = Array.isArray(value) ? value : typeof value === 'string' ? [value] : [];
                            return (
                                <TextAreaFormItem
                                    values={normalizedValue}
                                    label='intl-msg:includeDevices'
                                    placeholder='intl-msg:serialNumbers.prompt'
                                    validate={validateHwSerials}
                                    onChange={({ values }) => onChange(values)}
                                    errorMessage={'intl-msg:listContainsInvalidSerialNumber'}
                                />
                        );
                        }}
                    />
                </HeartWrapper>
            </div>
            <div id={FILTER_IDS.VINS_WHITELIST}>
                <HeartWrapper>
                    <Controller
                        name='vinList'
                        control={control}
                        render={({ field: { value = [], onChange } }) => {
                            const normalizedValue = Array.isArray(value) ? value : typeof value === 'string' ? [value] : [];
                            return (
                                <TextAreaFormItem
                                    values={normalizedValue}
                                    label='intl-msg:includeVinList'
                                    placeholder='intl-msg:vinList.prompt'
                                    validate={validateVINs}
                                    onChange={({ values }) => onChange(values)}
                                    errorMessage={'intl-msg:listContainsInvalidVIN'}
                                />


                            );
                        }}
                    />
                </HeartWrapper>
            </div>
            <div id={FILTER_IDS.SHORT_VINS_WHITELIST}>
                <HeartWrapper>
                    <Controller
                        name='shortVinList'
                        control={control}
                        render={({ field: { value = [], onChange } }) => {
                            const normalizedValue = Array.isArray(value) ? value : typeof value === 'string' ? [value] : [];
                            return (
                                <TextAreaFormItem
                                    values={normalizedValue}
                                    label='intl-msg:deviceWhitelistByShortVINs'
                                    placeholder='intl-msg:shortVinList.prompt'
                                    validate={validateShortVINs}
                                    onChange={({ values }) => onChange(values)}
                                    errorMessage={'intl-msg:listContainsInvalidShortVIN'}
                                />
                            );
                        }}
                    />
                </HeartWrapper>
            </div>
        </div>
    );
};

export default IncludeDevicesSection;
